import React from 'react';
import { Box, Typography } from '@material-ui/core';

export interface FormFieldContainerProps {
  title: string;
  description?: string;
  helperText?: string;
  error?: boolean;
  ariaId: string;
  ariaDescribedBy: string;
  required?: boolean;
  pl?: number;
}

const FormFieldContainer: React.FC<FormFieldContainerProps> = (props) => {
  const { title, description, helperText, error, ariaId, ariaDescribedBy, required, children, pl } = props;

  return (
    <Box id={ariaId} marginTop={4} marginBottom={4} paddingLeft={pl ?? 1} paddingRight={1} width='100%'>
      <span>
        <Typography variant='body1' display='inline' component='label' htmlFor={ariaId} style={{ fontWeight: 600 }}>
          {title}
        </Typography>
        {required ? (
          <Typography
            variant='body1'
            display='inline'
            color='error'
            component='span'
            style={{ fontWeight: 'bolder', marginLeft: 4 }}
          >
            {'*'}
          </Typography>
        ) : null}
      </span>
      {description && (
        <Typography
          style={{ marginBottom: 8, marginTop: 4 }}
          variant='body2'
          color='textSecondary'
          id={ariaDescribedBy}
        >
          {description}
        </Typography>
      )}

      {children}

      {helperText && (
        <Typography color={error ? 'error' : 'textSecondary'} variant='body2' style={{ marginTop: 4 }}>
          {helperText}
        </Typography>
      )}
    </Box>
  );
};

export { FormFieldContainer };
